// extracted by mini-css-extract-plugin
export default {"card":"sharedCardStyles-module__card__yh4vt"};